/**
 * Base URL for auth redirects (OAuth callback, email confirmation).
 * Use VITE_SITE_URL in .env.local for local dev; leave unset for production (uses current origin).
 */
export function getBaseUrl(): string {
  const env = import.meta.env.VITE_SITE_URL as string | undefined;
  if (env?.trim()) {
    return env.includes("http") ? env.trim() : `https://${env.trim()}`;
  }
  if (typeof window !== "undefined") {
    return window.location.origin;
  }
  return "http://localhost:8080";
}
